<div class="login-page-container">
  <div class="login-content">
   <app-navbar></app-navbar>
    <app-form-loggin></app-form-loggin>
  </div>
  <app-footer></app-footer>
</div>